<template>
  <b-card title="Radar Chart">
    <chartjs-component-radar-chart
      :height="355"
      :data="radarChart.data"
      :options="radarChart.options"
    />
  </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue";
import ChartjsComponentRadarChart from "../charts-components/ChartjsComponentRadarChart.vue";

export default {
  components: {
    ChartjsComponentRadarChart,
    BCard,
  },
  data() {
    const chartColors = {
      primaryColorShade: "#836AF9",
      yellowColor: "#ffe800",
      successColorShade: "#28dac6",
      warningColorShade: "#ffe802",
      warningLightColor: "#FDAC34",
      infoColorShade: "#299AFF",
      greyColor: "#4F5D70",
      blueColor: "#2c9aff",
      blueLightColor: "#84D0FF",
      greyLightColor: "#EDF1F4",
      tooltipShadow: "rgba(0, 0, 0, 0.25)",
      lineChartPrimary: "#666ee8",
      lineChartDanger: "#ff4961",
      labelColor: "#6e6b7b",
      grid_line_color: "rgba(200, 200, 200, 0.2)",
    };

    return {
      radarChart: {
        data: {
          labels: ["STA", "STR", "AGI", "VIT", "CHA", "INT"],
          datasets: [
            {
              label: "Donté Panlin",
              data: [25, 59, 90, 81, 60, 82],
              fill: true,
              backgroundColor: "rgba(255,161,161, 0.9)",
              borderColor: "transparent",
              pointBackgroundColor: "transparent",
              pointBorderColor: "transparent",
            },
            {
              label: "Mireska Sunbreeze",
              data: [40, 100, 40, 90, 40, 90],
              fill: true,
              backgroundColor: "rgba(155,136,250, 0.9)",
              borderColor: "transparent",
              pointBackgroundColor: "transparent",
              pointBorderColor: "transparent",
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          responsiveAnimationDuration: 500,
          legend: {
            position: "top",
            labels: {
              padding: 25,
              fontColor: chartColors.labelColor,
            },
          },
          tooltips: {
            enabled: false,
            custom(tooltip) {
              const tooltipEl = document.getElementById("tooltip");
              if (tooltip.body) {
                tooltipEl.style.display = "block";
                if (tooltip.body[0].lines && tooltip.body[0].lines[0]) {
                  // eslint-disable-next-line prefer-destructuring
                  tooltipEl.innerHTML = tooltip.body[0].lines[0];
                }
              } else {
                setTimeout(() => {
                  tooltipEl.style.display = "none";
                }, 500);
              }
            },
          },
          gridLines: {
            display: false,
          },
          scale: {
            ticks: {
              maxTicksLimit: 1,
              display: false,
              fontColor: chartColors.labelColor,
            },
            gridLines: {
              color: chartColors.grid_line_color,
            },
            angleLines: { color: chartColors.grid_line_color },
          },
        },
      },
    };
  },
};
</script>
